import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CoinBalanceProvider } from './context/CoinBalanceContext';
import { AdminGuard } from './components/AdminGuard';
import { Home } from './pages/Home';
import { Reader } from './pages/Reader';
import { Billing } from './pages/Billing';
import { BillingSuccess } from './pages/BillingSuccess';
import { Publisher } from './pages/Publisher';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminBooks } from './pages/admin/AdminBooks';
import { AdminUsers } from './pages/admin/AdminUsers';

function App() {
  return (
    <AuthProvider>
      <CoinBalanceProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book/:bookId/:chapterSeq?" element={<Reader />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/billing/success" element={<BillingSuccess />} />
          
          {/* Redirect old /publisher to /admin */}
          <Route path="/publisher" element={<Navigate to="/admin" replace />} />
          
          {/* Admin Routes - Protected */}
          <Route path="/admin" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
          <Route path="/admin/books" element={<AdminGuard><AdminBooks /></AdminGuard>} />
          <Route path="/admin/users" element={<AdminGuard><AdminUsers /></AdminGuard>} />
          <Route path="/admin/editor" element={<AdminGuard><Publisher /></AdminGuard>} />
        </Routes>
      </BrowserRouter>
      </CoinBalanceProvider>
    </AuthProvider>
  );
}

export default App;
